//src/pages/REG/REG100F1.jsx
import React, {useContext, useEffect, useRef, useState} from 'react';
import style from "./REG100F1.module.scss";
import toast from "components/Toast/Toast";
import Button from "components/Button/Button";
import SwitchGroup from "components/Button/SwitchGroup"
import InputUnitText from "components/InputText/InputUnitText";
import Table from "components/Table/Table";
import DatePicker from "components/DatePicker/DatePicker";
import {dateToYMD, ymdToDate} from './REGComUtil'; //
import {postData} from 'utils/TransactionUtil';
import {AuthContext} from "contexts/AuthContext";
import styleCom from "./REGCOM.module.scss";
import SelectBox from "../../components/SelectBox/SelectBox";

// 페이지 시작
const REG100F1 = ({navBar: NavBar}) => {

    const authContext = useContext(AuthContext);
    const userInfo = authContext.userInfo; // 사용자 정보 가져오기

    const initObj = [
        {name:"hsptCd", label: "등록기관", value: userInfo.hsptCd},
        {name:"initial", label: "대상자 영문 이니셜", value: ""},
        {name:"acquisitionDt", label: "동의서 취득일", value: ""},
        {name:"enrollDt", label: "Enroll Date", value: ""},
        {name:"age", label: "연령(만)", value: ""},
        {name:"sex", label: "성별", value: ""},
        //{name:"studyPid", label: "연구 등록번호", value: ""},
        {name:"eligibleYn", label: "적합 대상자 확인 여부", value: ""},
        {name:"include1Yn", label: "선정기준1", value: ""},
        {name:"include2Yn", label: "선정기준2", value: ""},
        {name:"include3Yn", label: "선정기준3", value: ""},
        {name:"include4Yn", label: "선정기준3", value: ""},
        {name:"exclude1Yn", label: "제외기준1", value: ""},
        {name:"exclude2Yn", label: "제외기준2", value: ""},
        {name:"exclude3Yn", label: "제외기준3", value: ""},
        {name:"exclude4Yn", label: "제외기준4", value: ""},
        {name:"exclude5Yn", label: "제외기준5", value: ""}
    ];

    const [comHsptObj, setComHsptObj] = useState([]);
    const [hsptObj, setHsptObj] = useState([]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [res, setRes] = useState({});
    const [param, setParam] = useState({});

    const refs = useRef([]);


    //const [inputFild, setInputFild] = useState(initObj);
    const inputFild = initObj;
    const [inputData, setInputData]  = useState(inputFild);
    const [isCheckCriteria, setIsCheckCriteria] = useState(false);

    useEffect(() => {
        //공통코드 호출
        getComDtlsCd("HSPT_CD");
        setItemValue("hsptCd", userInfo.hsptCd);

    }, []);

    useEffect(() => {
        const requiredNames = [ "include1Yn", "include2Yn", "include3Yn", "include4Yn"
                                     ,"exclude1Yn", "exclude2Yn", "exclude3Yn" , "exclude4Yn", "exclude5Yn"];
        const allExistAndHaveValue = requiredNames.every(name => {
            const field = inputData.find(f => f.name === name);
            return field && field.value != null && field.value !== '' && !(typeof field.value === 'string' && field.value.trim() === '');
        });

        if(allExistAndHaveValue){
            setIsCheckCriteria(false);
        }else{
            setIsCheckCriteria(true);
        }

    }, [inputData]);


    //저장 버튼 클릭
    const onClickSave = async (e) => {
        const getParam = Object.fromEntries(inputData.map(field => [field.name, field.value]));
        setParam(getParam);

        if (await validate()) {
            const getParam = Object.fromEntries(inputData.map(field => [field.name, field.value]));
            setParam(getParam);
            callAddNewCase(getParam).then(() => {
                setInputData(inputFild);
            });

        }
    }

    //데이터 셋팅 및 유효성 검사
    const validate = async () => {
        let valid = false;
        const hasEmptyString = inputData.some(item => item.value === '');

        //console.log("hasEmptyString : " + hasEmptyString);

        if(hasEmptyString){
            valid = false;
            toast({type: 'info', message: "미입력 항목이 존재합니다."});
        }
        /*
            //연구 등록번호 체크 해제 2025.11.3. 임현수 선생님 요청사항
            //New case 가 아닌 상세화면의 Demographics 에서 무작위군 부여
            else if (getItemValue('studyPid').length !== 8) {
                valid = false;
                toast({type: 'info', message: "연구 등록번호를 확인하여 주십시오."});
            }
            else if (await svcReadyCaseCheck() === false) {
                valid = false;
                toast({type: 'warning', message: "연구 등록번호를 찾을 수 없습니다."});
            }
         */

        else {
            valid = true;
        }

        return  valid;
    };

    //데이터 Setter
    const setItemValue = (name, value) => {
        setInputData(prevData =>
            prevData.map(item =>
                item.name === name && item.value !== value ? { ...item, value } : item
            )
        );
    };
    //데이터 getter
    const getItemValue = (getName) =>{
        return inputData.find(item => item.name === getName).value;
    }

    const getItemLabel = (getName) =>{
        return inputData.find(item => item.name === getName).label;
    }

    const handleChange_upper = (name, value) =>{
        //대문자로 입력값 변경
        const input = value;
        const onlyUppercase = input.replace(/[^A-Z]/g, '');
        setItemValue(name, onlyUppercase);

    }

    //inclusion All Yes 버튼
    const onClick_inclusionAllYes = () => {
        setItemValue("include1Yn", "Y");
        setItemValue("include2Yn", "Y");
        setItemValue("include3Yn", "Y");
        setItemValue("include4Yn", "Y");
    };

    //exclude All No 버튼
    const onClick_excludeAllNo = () => {
        setItemValue("exclude1Yn", "N");
        setItemValue("exclude2Yn", "N");
        setItemValue("exclude3Yn", "N");
        setItemValue("exclude4Yn", "N");
        setItemValue("exclude5Yn", "N");
    };


    /* Call Service===================================================================================================*/
    async function getComDtlsCd(grpCd) {
        const param = {comGrpCd:grpCd}
        const resultHsptData = await postData("/getComDtlsCd", param);
        setComHsptObj(resultHsptData);
        const hsptArray = resultHsptData.map(item => ({
            value: item.comnDtlsCd,
            label: item.detlCdNm
        }));
        setHsptObj(hsptArray);
    }

    async function callAddNewCase(getParam, setRes, setIsModalOpen) {
        let result = await postData("/RED/addNewCase", getParam);
        if(result === 200){
            toast({type: 'success', message: "등록이 완료되었습니다.", opt: {position: "top-center"}});
        }else{
            toast({type: 'error', message: "등록이 실패하였습니다.", opt: {position: "top-center"}});
        }

    }

    const svcReadyCaseCheck = async() => {
        //연구등록번호 체크
        let chkValue = false;
        const param ={ hsptCd: userInfo.hsptCd , studyPid : getItemValue("studyPid") };
        let result = await postData("/RED/readyCaseCheck", param);
        if(result.regChkYn==='Y'){
            chkValue = true;
        }else{
            chkValue = false;
        }
        return chkValue;

    }


///////////////////////////////

    return (
        <>
        <NavBar>
            {/*공통 영역*/}
            <div className={style.search_wrap}>
                <Button variant="Primary" size="md" addStyle={{width: "58px", height: "40px"}}
                        onClick={onClickSave}>
                    저장
                </Button>
            </div>
        </NavBar>

            {/*메인 영역*/}
            <div className={styleCom.root_wrap} style={{height: "750px", overflowY: "scroll"}}>
                {/*<div className={styleCom.title_wrap} style={{marginTop: "10px", marginBottom: '-20px'}}>*/}
                {/*    <h3>NEW CASE</h3>*/}
                {/*</div>*/}
                <div className={styleCom.main_wrap}>
                    <Table variant='default' rowCnt={3} colSize={['25%', '25%', '25%', '25%']} rowSize={'56px'}>
                        <div>{getItemLabel('hsptCd')}</div>
                        <div>
                            <SelectBox options={hsptObj} value={getItemValue("hsptCd")}
                                       valueKey="comnDtlsCd" labelKey="detlCdNm"
                                       onChange={(value) => setItemValue("hsptCd", value)}
                                       isDisabled={true} width={"51%"}/>
                        </div>
                        <div>{getItemLabel('initial')}</div>
                        <div>
                            <InputUnitText type={"text"} value={getItemValue('initial')} unit={""}
                                //onChange={(value) => setItemValue( 'initial', value)}/>
                                           onChange={(value) => handleChange_upper('initial', value.toUpperCase())}/>
                        </div>

                        <div>{getItemLabel("age")}</div>
                        <div>
                            <InputUnitText type={"number"} value={getItemValue("age")} unit={"세"}
                                           maxLength={3}
                                           onChange={(value) => setItemValue("age", value)}/>
                        </div>
                        <div>{getItemLabel('sex')}</div>
                        <div>
                            <SwitchGroup value={getItemValue("sex")}
                                         onClick={(value) => setItemValue("sex", value)}
                                         items={{"남성": "M", "여성": "F"}}
                            />
                        </div>
                        <div>{getItemLabel('enrollDt')}</div>
                        <div>
                            <DatePicker selDate={ymdToDate(getItemValue('enrollDt'))}
                                        dateFormat={'yyyy-MM-dd'}
                                        onChange={(date) => setItemValue('enrollDt', dateToYMD(date))}/>
                        </div>


                        {/*<div>{getItemLabel('studyPid')}</div>*/}
                        {/*<div>*/}
                        {/*    <InputUnitText type={"number"} value={getItemValue("studyPid")} unit={""}*/}
                        {/*                   maxLength={8}*/}
                        {/*                   onChange={(value) => setItemValue("studyPid", value)}/>*/}
                        {/*</div>*/}
                        <div>{getItemLabel('acquisitionDt')}</div>
                        <div>
                            <DatePicker selDate={ymdToDate(getItemValue('acquisitionDt'))}
                                        dateFormat={'yyyy-MM-dd'}
                                        onChange={(date) => setItemValue('acquisitionDt', dateToYMD(date))}/>
                        </div>

                    </Table>

                    <h3>선정/제외 기준평가</h3>
                    <Table variant='Vertical' rowCnt={12} colSize={['75%', '25%']} rowSize={'56px'}>
                        <div className={style.cellTyp1}>상기 시험 대상자는 선정/제외 기준을 만족하고, 관찰연구 참여에 적합합니까?
                            (선정/제외 기준을 모두 확인한 후 선택 가능합니다)
                        </div>
                        <div className={style.cellTyp2}>
                            <SwitchGroup value={getItemValue("eligibleYn")}
                                         onClick={(value) => setItemValue("eligibleYn", value)}
                                         items={{"YES": "Y", "NO": "N"}} isDisabled={isCheckCriteria}
                            />
                        </div>
                        <div className={"col_merge"} style={{justifyContent: 'left', backgroundColor: "#FAFAFA"}}>
                            <span className={style.cellHeader}>Inclusion Criteria</span>
                            <Button variant="Tertiary" size="md" addStyle={{width: "70px", height: "34px"}}
                                    onClick={() => onClick_inclusionAllYes()}>
                                All Yes
                            </Button>
                        </div>

                        <div className={style.cellTyp1}>1. 만 19세 이상</div>
                        <div className={style.cellTyp2}>
                            <SwitchGroup value={getItemValue("include1Yn")}
                                         onClick={(value) => setItemValue("include1Yn", value)}
                                         items={{"YES": "Y", "NO": "N"}}
                            />
                        </div>
                        <div className={style.cellTyp1}>2. 진료실 수축기 혈압 ≥ 140 mmHg 또는 이완기혈압 ≥ 90 mmHg
                        </div>
                        <div className={style.cellTyp2}>
                            <SwitchGroup value={getItemValue("include2Yn")}
                                         onClick={(value) => setItemValue("include2Yn", value)}
                                         items={{"YES": "Y", "NO": "N"}}
                            />
                        </div>
                        <div className={style.cellTyp1}>3. 새로이 혈압약을 복용하거나 기존 혈압약을 조절해야할 것으로 예상되는 환자</div>
                        <div className={style.cellTyp2}>
                            <SwitchGroup value={getItemValue("include3Yn")}
                                         onClick={(value) => setItemValue("include3Yn", value)}
                                         items={{"YES": "Y", "NO": "N"}}
                            />
                        </div>
                        <div className={style.cellTyp1}>4. 연구 참여에 서면 동의하고, 연구기간 동안 꾸준히 내원 및 추적관찰이 가능한 환자</div>
                        <div className={style.cellTyp2}>
                            <SwitchGroup value={getItemValue("include4Yn")}
                                         onClick={(value) => setItemValue("include4Yn", value)}
                                         items={{"YES": "Y", "NO": "N"}}
                            />
                        </div>
                        <div className={"col_merge"} style={{justifyContent: 'left', backgroundColor: "#FAFAFA"}}>
                            <span className={style.cellHeader}>Exclusion Criteria</span>
                            <Button variant="Tertiary" size="md" addStyle={{width: "70px", height: "34px"}}
                                    onClick={() => onClick_excludeAllNo()}>
                                All No
                            </Button>
                        </div>
                        <div className={style.cellTyp1}>
                            1. Olmesartan, amlodipine, hydrochlorothiazide 등 본 연구에서 사용 예정인 주요 약제에 대한 부작용 기왕력이 있는 환자
                        </div>
                        <div className={style.cellTyp2}>
                            <SwitchGroup value={getItemValue("exclude1Yn")}
                                         onClick={(value) => setItemValue("exclude1Yn", value)}
                                         items={{"YES": "Y", "NO": "N"}}
                            />
                        </div>
                        <div className={style.cellTyp1}>
                            2. 이차성 고혈압이 의심되는 환자
                        </div>
                        <div className={style.cellTyp2}>
                            <SwitchGroup value={getItemValue("exclude2Yn")}
                                         onClick={(value) => setItemValue("exclude2Yn", value)}
                                         items={{"YES": "Y", "NO": "N"}}
                            />
                        </div>
                        <div className={style.cellTyp1}>
                            3. 심방세동이 있는 환자
                        </div>
                        <div className={style.cellTyp2}>
                            <SwitchGroup value={getItemValue("exclude3Yn")}
                                         onClick={(value) => setItemValue("exclude3Yn", value)}
                                         items={{"YES": "Y", "NO": "N"}}
                            />
                        </div>
                        <div className={style.cellTyp1}>
                            4. 임신 중이거나 수유 중인 여성
                        </div>
                        <div className={style.cellTyp2}>
                            <SwitchGroup value={getItemValue("exclude4Yn")}
                                         onClick={(value) => setItemValue("exclude4Yn", value)}
                                         items={{"YES": "Y", "NO": "N"}}
                            />
                        </div>
                        <div className={style.cellTyp1}>
                            5. 기타 심각한 내과적 질환 등으로 연구 참여가 어렵거나 연구 수행에 지장이 있을 수 있는 환자
                        </div>
                        <div className={style.cellTyp2}>
                            <SwitchGroup value={getItemValue("exclude5Yn")}

                                         onClick={(value) => setItemValue("exclude5Yn", value)}
                                         items={{"YES": "Y", "NO": "N"}}
                            />
                        </div>



                    </Table>
                </div>

            </div>

            {/*<Modal*/}
            {/*    open={isModalOpen}*/}
            {/*    handle_Close={() => setIsModalOpen(false)}*/}
            {/*    title="입력정보"*/}
            {/*    width="1220px"*/}
            {/*    height="900px"*/}
            {/*    isHeader={true}*/}
            {/*    isBottom={false}>*/}
            {/*    <ConfirmModal param={param} res={res}/>*/}
            {/*</Modal>*/}

    </>
    );
};



export default REG100F1;
